// extracted by mini-css-extract-plugin
export default {"tabletCollapsableContainer":"main-menu-tablet_tabletCollapsableContainer__eAPMW","icon":"main-menu-tablet_icon__+jhYH"};